import * as yup from 'yup';
import { UseFormProps } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ICompany, ICompanyCreation } from '@entities/companies'; // Import ICompanyDetail if not already imported
import {
  REQUIRED_BANK_ACCOUNT_NUMBER,
  REQUIRED_BANK_ADDRESS,
  REQUIRED_BANK_CODE,
  REQUIRED_BANK_NAME,
  REQUIRED_BASED_ON_DOCUMENT,
  REQUIRED_COMPANY_ADDRESS,
  REQUIRED_COUNTRY_NAME_ID,
  REQUIRED_NAME,
  REQUIRED_REGISTRATION_CODE,
  REQUIRED_REPRESENTATIVES_NAME,
  REQUIRED_ROLE,
} from '@pages/companies/company-creation-form/lib/constants/form-error.constants';

const companyDetailSchema = yup.object().shape({
  name: yup.string().required(REQUIRED_NAME),
  registrationCode: yup.string().required(REQUIRED_REGISTRATION_CODE),
  representativesName: yup.string().required(REQUIRED_REPRESENTATIVES_NAME),
  role: yup.string().required(REQUIRED_ROLE),
  basedOnTheDocument: yup.string().required(REQUIRED_BASED_ON_DOCUMENT),
  bankName: yup.string().required(REQUIRED_BANK_NAME),
  bankAddress: yup.string().required(REQUIRED_BANK_ADDRESS),
  countryId: yup.string().required(REQUIRED_COUNTRY_NAME_ID),
  bankCode: yup.string().required(REQUIRED_BANK_CODE),
  bankAccountNumber: yup.string().required(REQUIRED_BANK_ACCOUNT_NUMBER),
  companyAddress: yup.string().required(REQUIRED_COMPANY_ADDRESS),
  countryName: yup.string().required(REQUIRED_COMPANY_ADDRESS),
});

const primaryCompanyDetailSchema = yup.object().shape({
  name: yup.string().required(REQUIRED_NAME),
  registrationCode: yup.string().required(REQUIRED_REGISTRATION_CODE),
  representativesName: yup.string().required(REQUIRED_REPRESENTATIVES_NAME),
  role: yup.string().required(REQUIRED_ROLE),
  basedOnTheDocument: yup.string().required(REQUIRED_BASED_ON_DOCUMENT),
  bankName: yup.string().required(REQUIRED_BANK_NAME),
  bankAddress: yup.string().required(REQUIRED_BANK_ADDRESS),
  countryId: yup.string().required(REQUIRED_COUNTRY_NAME_ID),
  bankCode: yup.string().required(REQUIRED_BANK_CODE),
  bankAccountNumber: yup.string().required(REQUIRED_BANK_ACCOUNT_NUMBER),
  companyAddress: yup.string().required(REQUIRED_COMPANY_ADDRESS),
});

const CompanyCreationSchema = yup.object().shape({
  primaryCompanyDetails: primaryCompanyDetailSchema,
  companyDetailsList: yup.array().of(companyDetailSchema).required(),
});

export const setup = (defaultValues: ICompany) => {
  const options: UseFormProps<ICompanyCreation> = {
    defaultValues: {
      primaryCompanyDetails: defaultValues,
      companyDetailsList: defaultValues.companyDetailsList,
    },
    resolver: yupResolver<ICompanyCreation>(CompanyCreationSchema),
  };

  return options;
};
